<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./suffix.scss";
</style>

<template>
  <div class="suffix" v-if="hasSuffix && variant !== 'display'">
    <div class="label">{{ suffixLabel }}</div>
    <svg class="icon feather" v-if="hasIcon">
      <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "SuffixComponent",
  props: {
    hasSuffix: { type: Boolean },
    variant: { type: String },
    suffixLabel: { type: String },
    hasIcon: { type: Boolean },
    icon: { type: String },
  },
};
</script>
